import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=64312fa5&"
import script from "./EditUserProfile.vue?vue&type=script&lang=ts&"
export * from "./EditUserProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports